








import { useChannelsStore } from "@/store/useChannelsStore";
import messageParser from "@/utils/messageParser";
import { textIsOnlyEmoji } from "@/utils/v3/chat.utils";
import { EntryDirection, TextEntryDto } from "@saysimple-platform/dtos";
import { computed, defineComponent, PropType } from "@vue/composition-api";
import ParsedMessage from "./parsedMessage.vue";

export default defineComponent({
    components: {
        ParsedMessage,
    },
    props: {
        entry: {
            type: Object as PropType<TextEntryDto>,
            required: true,
        },
        groupDirection: {
            type: String as PropType<EntryDirection>,
            required: false,
        },
    },
    setup(props) {
        const channelsStore = useChannelsStore();

        const isOnlyEmoji = computed((): boolean => textIsOnlyEmoji(props.entry.message));
        return {
            channelsStore,
            messageParser,
            isOnlyEmoji,
        };
    },
});
